/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  ListAffiliateProgramsOptions,
  ListAffiliateProgramsResponses,
} from '../types/ListAffiliatePrograms'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @description ADMIN or INTEGRATOR required. Integrators are restricted to their own tenant; ADMIN overrides other roles. Admins without a tenant filter list all tenants. Inactive programs are included.
 * @summary List affiliate programs
 * {@link /v1/affiliate_programs}
 */
export function listAffiliatePrograms<ThrowOnError extends boolean = true>(
  options: Options<ListAffiliateProgramsOptions, ThrowOnError> = {},
): Unwrappable<RequestResult<ListAffiliateProgramsResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'GET',
      url: '/v1/affiliate_programs',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<ListAffiliateProgramsResponses, ThrowOnError>>,
  )
}
